module.exports = __webpack_public_path__ + "media/images/product-image-placeholder-soon-4a190509db3ecc9c7e116f40244653b5.jpg";